<template>
    <FilterLayout title="Location">
        <div class="dealer-locator__location-filter">
            <input 
                class="form-control postcode-input" 
                type="text" 
                name="location" 
                placeholder="Postcode/Town" 
                data-location-element="true" 
                data-customer-location="true"
                autocomplete="off"

                ref="input"

                :value="filters.location"
            />
            <button type="button" class="btn btn--primary-inverted btn--full-width" @click="lookupLocation">
                <img width="18" height="18" src="/images/location-point.svg" />
                <span>Use my location</span>
            </button>
        </div>
    </FilterLayout>
</template>

<script>
    import { defineComponent } from "vue";
    import FilterLayout from "./Filter.vue";
    import { mapGetters } from 'vuex'
    import { mapState } from "vuex";

    export default defineComponent({
        name: 'Location',

        components: {
            FilterLayout,
        },

        data() {
            return {
                locationAllowed: true,
                autocomplete: false,
                googleClass: false,
            }
        },

        computed: {
            ...mapGetters({
                geoLocation: 'Dealers/geoLocation',
                userOptions: 'UsedSearchOptions/userOptions',
            }),
            ...mapState('DealerData', {
                filters: 'filters'
            }),
        },
        methods: {
            lookupLocation() {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.$store.commit('DealerData/setLocation', {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        });
                    },
                    (error) =>{
                        this.locationAllowed = false;
                    }
                );
            }
        },
        mounted() {
            //component children may not always be mountes in this hook, only the root parent
            //nextTick ensures children are also loaded
            this.$nextTick(function() {
                GoogleMapsLoader.getMap()
                    .then(googleClass => {
                        if (!this.$refs['input']) {
                            return;
                        }

                        this.googleClass = googleClass;
                        this.autocomplete = new googleClass.maps.places.Autocomplete(this.$refs['input']);
                        this.autocomplete.setComponentRestrictions({'country': ['gb']});
                        this.autocomplete.setFields(['geometry', 'place_id', 'name']);
                        this.autocomplete.addListener('place_changed', () => {
                            const place = this.autocomplete.getPlace();

                            this.$store.commit('DealerData/setLocation', {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                                location: this.$refs['input'].value
                            });
                        });
                    });
            });
        },
        beforeDestroy() {
            if (this.autocomplete && this.googleClass && this.$refs['input']) {
                this.googleClass.maps.event.clearInstanceListeners(this.$refs['input']);
                this.autocomplete.unbindAll();
            }
        },
    })
</script>